import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  DialogRef,
  DialogService,
} from '@cyborg-monorepo/common/angular/cyborg-ui';
import { Profile } from '@cyborg-monorepo/hunter/common';
import { CompanyService } from '../../../modules/shared/services/company.service';
import { UserService } from '../../../modules/shared/services/user.service';
import {
  TrackingEventEnum,
  TrackingService,
} from '../../../tracking/tracking.service';
import { requireCheckboxesToBeCheckedValidator } from './required-checkbox-validator';

@Component({ standalone: false, 
  selector: 'reactivate-dialog',
  templateUrl: './reactivate-dialog.component.html',
  styleUrls: ['./reactivate-dialog.component.scss'],
})
export class ReactivateDialogComponent implements OnInit, AfterContentChecked {
  public error: string;
  public submitted: boolean = false;
  public reactivateForm: FormGroup;
  public formV2: FormGroup;
  public form: FormGroup;
  public showCustomReason: boolean = false;

  public reactivationReasons: Array<string> = [
    'Build / mature Threat Hunting program',
    'Supplement in-house Hunting',
    'Leverage Hunt Packages with current SIEM & EDR',
    'Internal Push from Management',
    'Other',
  ];

  public profile: Profile;
  constructor(
    private userService: UserService,
    public dialogRef: DialogRef,
    public dialog: DialogService,
    private companyService: CompanyService,
    private trackingService: TrackingService,
    private cdref: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.form = new FormGroup({
      checkboxes: new FormGroup({}, requireCheckboxesToBeCheckedValidator()),
    });

    this.reactivationReasons.forEach((item) => {
      (this.form.controls['checkboxes'] as FormGroup).addControl(
        item,
        new FormControl(false),
      );
    });

    this.form.addControl(
      'additionalInfo',
      new FormControl('', Validators.required),
    );

    this.userService.getProfile().subscribe((profile) => {
      this.profile = profile;
    });
  }

  public ngAfterContentChecked(): void {
    this.cdref.detectChanges();
  }

  public get checkboxGroup(): FormGroup {
    return this.form.controls['checkboxes'] as FormGroup;
  }

  public onReactivate(): void {
    this.companyService.reactivateCompany().subscribe(
      () => {
        this.trackingService.trackEvent(
          TrackingEventEnum.COMMUNITY_REACTIVATION_REACTION,
          {
            reason: this.form.value,
            user: this.profile,
          },
        );
        this.submitted = true;
      },
      (error) => {
        this.error = error.message;
      },
    );
  }

  public returnToResearch(): void {
    this.dialogRef.close(true);
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
